/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Constraint } from './constraint';
import { DynamicOperand } from './dynamicOperand';


export interface DeltaConstraint extends Constraint { 
    delta: number;
    operand1: DynamicOperand;
    type: DeltaConstraint.TypeEnum;
}
export namespace DeltaConstraint {
    export type TypeEnum = 'DAY' | 'WEEK' | 'MONTH' | 'YEAR';
    export const TypeEnum = {
        DAY: 'DAY' as TypeEnum,
        WEEK: 'WEEK' as TypeEnum,
        MONTH: 'MONTH' as TypeEnum,
        YEAR: 'YEAR' as TypeEnum
    };
}
